// import React from "react";
// import { Outlet, Route, Routes } from "react-router-dom";
// import Header from '../components/Frontend/Header';
// import Footer from '../components/Frontend/Footer';
// import AuthNavbar from "components/Navbars/AuthNavbar.jsx";
// /*import Footer from "components/Footer/Footer.jsx";*/

// import routes from "routes.js";

// var ps;

// class Pages extends React.Component {
//   componentDidMount() {
//     if (navigator.platform.indexOf("Win") > -1) {
//       //ps = new PerfectScrollbar(this.refs.fullPages);
//     }
//   }
//   componentWillUnmount() {
//     if (navigator.platform.indexOf("Win") > -1) {
//       //ps.destroy();
//     }
//   }
//   getRoutes = routes => {
//     return routes.map((prop, key) => {
//       if (prop.collapse) {
//         return this.getRoutes(prop.views);
//       }
//       console.log("prop.layout===",prop.layout);

//       if (prop.layout === "/auth") {
//         const Component = prop.component;
//         return (
//           <Route
//             path={prop.layout + prop.path}
//             element={<Component />}
//             key={key}
//           />
//         );
//       } else {
//         return null;
//       }
//     });
//   };
//   render() {

//     console.log("inside authlayout");
//     console.log("routes===",routes);


//     return (
//       <>
//         <Header />
//             {/* <Routes>{this.getRoutes(routes)}</Routes> */}
//             <Outlet/>
//         <Footer />
//       </>
//     );
//   }
// }

// export default Pages;

import React, { useEffect } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import AuthNavbar from "components/Navbars/AuthNavbar.jsx";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import routes from "routes";
/*import Footer from "components/Footer/Footer.jsx";*/

// import routes from "../routes-minimal.js";

let ps;

const Pages = () => {
  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      //ps = new PerfectScrollbar(this.refs.fullPages);
    }

    return () => {
      if (navigator.platform.indexOf("Win") > -1) {
        //ps.destroy();
      }
    };
  }, []);

  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        const Component = prop.component;
        return (
          <Route
            path={prop.layout + prop.path}
            element={<Component />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };


  return (
    <>
      <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}>
        <Header />
        <Routes>
          {routes.map((prop, key) => {
            if (prop.collapse) {
              return prop.views.map((view, viewKey) => {
                if (view.layout === "/auth") {
                  const Component = view.component;
                  return (
                    <Route
                      key={`${key}-${viewKey}`}
                      path={view.path}
                      element={<Component />}
                    />
                  );
                }
                return null;
              });
            }
            if (prop.layout === "/auth") {
              const Component = prop.component;
              return (
                <Route
                  key={key}
                  path={prop.path}
                  element={<Component />}
                />
              );
            }
            return null;
          })}
        </Routes>
        <Footer />
      </GoogleReCaptchaProvider>
    </>
  );
};

export default Pages;